angular.module('bribac.components.whenLoaded', [])

  .component('whenLoaded', {
    templateUrl: 'when-loaded-component.html',
    transclude: true,
    controller: 'WhenLoadedComponentCtrl',
    bindings: {
      promise: '<'
    }
  })

  .controller('WhenLoadedComponentCtrl', function() {
    var $ctrl = this

    $ctrl.$onChanges = function(changes) {
      var promise = changes.promise.currentValue

      $ctrl.loading = false
      $ctrl.previousSuccess = $ctrl.success
      $ctrl.success = null
      $ctrl.error = null
      $ctrl.errorMessage = ''

      if (promise) {
        $ctrl.loading = true

        promise
          .finally(function() {
            $ctrl.loading = false
          })
          .then(
            function success() {
              $ctrl.success = true
            },

            function error(request) {
              $ctrl.error = true
              var message = request.statusText || 'Unknown'
              if (request instanceof Error) {
                console.error(request)
                message = 'Unknown'
              }
              $ctrl.errorMessage = 'Error: ' + message
            }
          )
      }

    }
  })
